import { OndigoNS } from '../modules/main.js';

(function ($) {
    'use strict';

    // class definition
    OndigoNS.AdjustBoxHeight = function (element) {
        var that = this;

        this.$columnContainer = $(element);

        $(window).on('load', function () {
            that.setIdentHeight();
        });
        $(window).on('resize', function () {
            that.setIdentHeight();
        });
        return {
            updateIdentHeight : function () {
                that.setIdentHeight();
            },
            removeIdentHeight : function () {
                that.removeIdentHeight();
            }
        };
    };

    OndigoNS.AdjustBoxHeight.prototype = {
        setIdentHeight: function () {
            $.each(this.$columnContainer, function () {
                var $childElements = $(this).children(),
                    heights = [],
                    maxHeight;

                // add all heights to the array
                $.each($childElements, function () {
                    $(this).css('height','');
                    heights.push($(this).height());
                });

                // get the highest height in the array
                maxHeight = OndigoNS.Utils.maxValueInArray(heights);

                // assign the highest height to all elements
                $.each($childElements, function () {
                    if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                        if ($(this).parent().hasClass('onSmartphoneIdentHeight')) {
                            $(this).height(maxHeight);
                        }
                    }
                    else {
                        $(this).height(maxHeight);
                    }
                });
            });
        },
        removeIdentHeight: function () {
            $.each(this.$columnContainer, function () {
                if (OndigoNS.Utils.getWindowInnerWidth() < OndigoNS.breakpointWide) {
                    if (!$(this).hasClass('onSmartphoneIdentHeight')) {
                        var $childElements = $(this).children();

                        // remove all heights to the array
                        $.each($childElements, function () {
                            $(this).css('height','');
                        });
                    }
                }
            });
        }
    };

    // plugin definition
    $.fn.adjustBoxHeight = function () {
        return new OndigoNS.AdjustBoxHeight(this);
    };
    $.fn.adjustBoxHeight.Constructor = OndigoNS.AdjustBoxHeight;


}(window.jQuery));

$(document).ready(function () {
    'use strict';

    OndigoNS.Utils.createIdentHeight();
});